import { RiEyeLine, RiEditLine } from "react-icons/ri";
import Button from "../../Components/Button";
import { Link } from "react-router-dom";

export const config = (withFilter, onView) => [
  {
    name: "Num Dossier",
    selector: (row) => row.reference,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Montant",
    selector: (row) => row.simulation.amount,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Durée/Mois",
    selector: (row) => row.simulation.duration,
    sortable: true,
    filterable: withFilter,
    maxWidth: "100px !important",
  },

  {
    name: "Autofinancement",
    selector: (row) => row.simulation.self_financing,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Résultat",
    selector: (row) => row.simulation.result_amount,
    sortable: true,
    maxWidth: "150px !important",
    filterable: withFilter,
  },
  {
    name: "Type de Bien",
    selector: (row) => row.simulation.product_name,
    sortable: true,
    filterable: withFilter,
  },
  {
    name: "Statut",
    sortable: true,
    filterable: withFilter,

    // style: {
    //   justifyContent: "center",
    // },

    selector: (row) => row.status_text,
    conditionalCellStyles: [
      {
        when: (row) => row.status === "rejected",
        classNames: ["chip-component danger"],
      },
      {
        when: (row) => row.status === "accpeted",
        classNames: ["chip-component success"],
      },
      {
        when: (row) => row.status === "in_progress",
        classNames: ["chip-component info"],
      },
      {
        when: (row) => row.status === "pending",
        classNames: ["chip-component primary"],
      },
      {
        when: (row) => row.status === "more_information",
        classNames: ["chip-component warning"],
      },
    ],
  },
  {
    name: "Actions",
    selector: (row) => row.id,
    cell: (row) => (
      <>
        {row.not_done ? (
          <Link
            title="Compléter votre demande de financement"
            className="link-edit-financing-list"
            to={`/financing-request/information-applicant/${row.simulation_id}`}
          >
            <RiEditLine />
          </Link>
        ) : (
          <Button
            view="clear"
            variant="dark"
            isIconButton
            title="Voir"
            onClick={() => onView(row.simulation_id)}
          >
            <RiEyeLine />
          </Button>
        )}
      </>
    ),
  },
];
